import React, { Component } from 'react';
import './Disclaimer.css';

class Disclaimer extends Component {
    render () {
        return (
            <div className="component-card-content">
                <h1 className="more-info-title">Website Disclaimer</h1>
                <p>
                    blabla...
                    The statistical model used in this application is based on the following paper:
                </p>
            </div>
        );
    }
}

export default Disclaimer;